// src/pages/admin/HealthPage.jsx -- already existed, but write fresh in case stub
import { useQuery } from '@tanstack/react-query'
import { adminHealthApi } from '../../api/services'
import { Card, CardBody, PageSpinner } from '../../components/common/ui'
import { RefreshCw } from 'lucide-react'

export default function HealthPage() {
  const { data, isLoading, refetch, isFetching } = useQuery({ queryKey: ['admin-health'], queryFn: () => adminHealthApi.check(), refetchInterval: 30000 })
  const health = data?.data?.data || {}

  const dot = (up) => <span className={`w-2.5 h-2.5 rounded-full inline-block ${up ? 'bg-green-400' : 'bg-red-500'}`} />

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-display font-bold">System Health</h1>
        <button onClick={() => refetch()} className="p-2 rounded-lg hover:bg-surface"><RefreshCw size={16} className={isFetching ? 'animate-spin text-pink' : 'text-muted'} /></button>
      </div>
      {isLoading && <PageSpinner />}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {Object.entries(health).map(([key, val]) => (
          <Card key={key}>
            <CardBody className="flex items-center justify-between">
              <div>
                <p className="font-bold text-sm capitalize">{key.replace(/_/g,' ')}</p>
                {val?.message && <p className="text-xs text-muted mt-0.5">{val.message}</p>}
                {val?.value != null && <p className="text-xs text-muted">{val.value}</p>}
              </div>
              {dot(val?.status === 'ok' || val === true || val?.status === 'up')}
            </CardBody>
          </Card>
        ))}
        {!isLoading && Object.keys(health).length === 0 && <p className="text-sm text-muted col-span-3 text-center py-8">No health data.</p>}
      </div>
    </div>
  )
}
